import { RecordDeliverableDestination, RecordDeliverableFormat } from "@modules/records/types/record";
import { TaskTemplate } from "./task-template";

export type ServerTemplateType = 'aws' | 'selfHosted' | 'docker';

export interface AwsOverrides {
  region?: string;
  imageId?: string;
  instanceType?: string;
  subnetId?: string;
  securityGroupIds?: string[];
}

export class ServerTemplate {
  id?: string;
  serverName?: string;
  serverKey?: string;
  type?: ServerTemplateType;
  version?: string;
  taskTemplates?: TaskTemplate[];
  deliverables?: {
    format: RecordDeliverableFormat;
    destinations: RecordDeliverableDestination[];
  }[] = [];
  settings?: any;
  awsOverrides?: AwsOverrides | null;   // null explicitly clears the stored overrides
  sortOrder?: number;
  createdAt?: string;
  updatedAt?: string;


  static createDefault(): ServerTemplate {
    return {
      serverName: 'Server',
      serverKey: '',
      type: 'aws',
      version: '1.0.0',
      deliverables: [],
      settings: {
        disks: [
          'E',
        ],
        s5cmdPath: 'C:\\tools\\s5cmd.exe',
        targetPath: 'E:\\trimmed\\',
        downloadPath: 'E:\\downloaded\\',
        connex: 'C:\\tools\\ConneX\\',
        audioPresetPath: 'C:\\tools\\audio.json',
        mmcGenerator: 'C:\\tools\\mmc-generator\\MediaManifestXmlGenerator.exe',
        awsSnsTopic: 'arn:aws:sns:us-east-1:435634566547:Roadrunner-Dev'
      }
    }
  }

  static createGeneralDefault(): ServerTemplate {
    return {
      serverName: 'Server',
      serverKey: '',
      type: 'aws',
      version: '1.0.0',
      deliverables: [
        {
          format: 'ts',
          destinations: ['backup']
        },
        {
          format: 'dnx',
          destinations: ['backup']
        },
        {
          format: 'j2ki',
          destinations: ['max', 'vod']
        },
        {
          format: 'j2kp',
          destinations: ['maxChimera']
        },
        {
          format: 'xdcam',
          destinations: ['linear']
        },
      ],
      settings: {
        disks: [
          'E',
          'D',
          'F',
        ],
        s5cmdPath: 'C:\\tools\\s5cmd.exe',
        targetPath: 'E:\\trimmed\\',
        downloadPath: 'E:\\downloaded\\',
        connex: 'C:\\tools\\ConneX\\',
        audioPresetPath: 'C:\\tools\\audio.json',
        mmcGenerator: 'C:\\tools\\mmc-generator\\MediaManifestXmlGenerator.exe',
        awsSnsTopic: 'arn:aws:sns:us-east-1:435634566547:Roadrunner-Dev'
      }
    }
  }
}